// src/store/index.js
import { createStore } from 'vuex';

// 从 sessionStorage 恢复标签页列表
const restoreVisitedViews = () => {
  try {
    const saved = sessionStorage.getItem('visitedViews');
    return saved ? JSON.parse(saved) : [];
  } catch { return []; }
};

const saveVisitedViews = (views) => {
  sessionStorage.setItem('visitedViews', JSON.stringify(views));
};

export default createStore({
  state: {
    isAuthenticated: !!localStorage.getItem('token'), // 初始化时从 localStorage 中读取 token，判断是否已认证
    token: localStorage.getItem('token') || null, // 初始化时从 localStorage 中读取 token
    mapState: null, // 存储地图状态
    selectedCollectionId: localStorage.getItem('selectedCollectionId') || null, // 初始化时从 localStorage 中读取合集 ID
    visitedViews: restoreVisitedViews(), // 多标签页：从 sessionStorage 恢复
  },
  mutations: {
    SET_AUTHENTICATED(state, isAuthenticated) {
      state.isAuthenticated = isAuthenticated;
    },
    SET_TOKEN(state, token) {
      state.token = token;
      if (token) {
        localStorage.setItem('token', token); // 将 token 保存到 localStorage
      } else {
        localStorage.removeItem('token'); // 如果 token 为空，从 localStorage 中移除
      }
    },
    SET_MAP_STATE(state, mapState) {
      state.mapState = mapState;
    },
    SET_SELECTED_COLLECTION_ID(state, id) {
      state.selectedCollectionId = id;
      if (id) {
        localStorage.setItem('selectedCollectionId', id);
      } else {
        localStorage.removeItem('selectedCollectionId');
      }
    },
    // 多标签页管理
    ADD_VISITED_VIEW(state, view) {
      if (state.visitedViews.some(v => v.path === view.path)) return;
      state.visitedViews.push({ path: view.path, fullPath: view.fullPath, title: view.title });
      saveVisitedViews(state.visitedViews);
    },
    DEL_VISITED_VIEW(state, path) {
      const index = state.visitedViews.findIndex(v => v.path === path);
      if (index > -1) state.visitedViews.splice(index, 1);
      saveVisitedViews(state.visitedViews);
    },
    DEL_OTHER_VISITED_VIEWS(state, path) {
      state.visitedViews = state.visitedViews.filter(v => v.path === path || v.path === '/accumulation');
      saveVisitedViews(state.visitedViews);
    },
  },
  actions: {
    login({ commit }, token) {
      commit('SET_AUTHENTICATED', true);
      commit('SET_TOKEN', token);
    },
    logout({ commit }) {
      commit('SET_AUTHENTICATED', false);
      commit('SET_TOKEN', null);
    },
    setMapState({ commit }, mapState) {
      commit('SET_MAP_STATE', mapState);
    },
    setSelectedCollectionId({ commit }, id) {
      commit('SET_SELECTED_COLLECTION_ID', id);
    },
  },
  getters: {
    isAuthenticated: (state) => state.isAuthenticated,
    token: (state) => state.token,
    mapState: (state) => state.mapState,
    selectedCollectionId: (state) => state.selectedCollectionId,
    visitedViews: (state) => state.visitedViews,
  },
});